import React from "react";
import { BulkMessageHeader } from "./BulkMessageHeader";
import { BulkMessageDataCells } from "./BulkMessageDataCells";
import { BulkMessageTable } from "./BulkMessageTable";
import { useOrg } from "@/hooks/useOrg";
import { RecentlyContactedCarousel } from "./RecentlyContactedCarousel";

export const BulkMessageOverview = () => {
  const { org, loading: orgLoading, error: orgError } = useOrg();

  return (
    <>
      <BulkMessageHeader />

      <div className="flex flex-col gap-6 p-6">
        <div className="mb-2 flex gap-6">
          <section className="flex w-[264px] flex-col gap-6">
            <BulkMessageDataCells
              orgId={org?.id}
              orgIdLoading={orgLoading}
              orgIdError={orgError}
            />
          </section>
          <section className="w-full max-w-[calc(100%-264px)]">
            <RecentlyContactedCarousel />
          </section>
        </div>

        <BulkMessageTable />
      </div>
    </>
  );
};
